import { setLocale as setUmiLocale, useIntl, getIntl, setIntl, getLocale } from 'umi';
import 'moment/locale/zh-cn';
import { useCallback } from 'react';
import { setSentryUser } from './sentry';

export type Language = 'zh-CN' | 'en' | 'ja' | 'ko-KR';

export type Locale = 'zh' | 'zh-CN' | 'en' | 'en-US' | 'ja' | 'ja-JP' | 'ko' | 'ko-KR';

export const LANGUAGES: string[] = ['zh-CN', 'en'];

export const [LANGUAGE] = LANGUAGES;
export const [CHINESE, ENGLISH] = LANGUAGES;

export const LOCALES: Record<Locale, Language> = {
  en: 'en',
  'en-US': 'en',
  zh: 'zh-CN',
  'zh-CN': 'zh-CN',
  ja: 'ja',
  'ja-JP': 'ja',
};

export const LOCALE = LOCALES[LANGUAGE] as Locale;

export const setLocale = (language: string, force = true) => {
  let meetingLang = '';
  if (language.startsWith('zh-') || language === 'zh') {
    meetingLang = 'zh-CN';
  } else if (language.startsWith('ja-') || language === 'ja') {
    meetingLang = 'ja';
  } else {
    meetingLang = 'en';
  }
  setUmiLocale(meetingLang, force);
  setSentryUser({
    userAgent: navigator.userAgent,
    userLanguage: `${navigator.language}`,
    meetingLanguage: meetingLang,
  });
};

// 国际化hooks
export const useI18N = function () {
  const { formatMessage } = useIntl();
  const $l = useCallback(
    (messageId: string, ...args: any[]) => formatMessage({ id: messageId }, ...args),
    [formatMessage]
  );
  return $l;
};

// react外部使用的国际化
export const getFormatMessage = function (messageId: string, ...args: any[]) {
  const { formatMessage } = getIntl();
  return formatMessage({ id: messageId }, ...args);
};
